module.exports = __webpack_public_path__ + "static/media/venetian07.73423957.png";